import { render, staticRenderFns } from "./q4.vue?vue&type=template&id=b06f0e16"
import script from "./q4.vue?vue&type=script&lang=js"
export * from "./q4.vue?vue&type=script&lang=js"
import style0 from "./q4.vue?vue&type=style&index=0&id=b06f0e16&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports